export const CELESTIA_PRO_PATHS = {
  root: "/celestia-pro",
  supportMode: "/celestia-pro/support-mode",
  businessMode: "/celestia-pro/business-mode",
  clones: "/celestia-pro/clones"
} as const

/** `?tab=` values of the tabbed page these routes replaced; backend descriptors, FAQ guides and old messages still carry them. */
const LEGACY_TAB_PATHS: Readonly<Record<string, string>> = {
  "support-pro": CELESTIA_PRO_PATHS.supportMode,
  "ai-business-mode": CELESTIA_PRO_PATHS.businessMode,
  "multi-bot": CELESTIA_PRO_PATHS.clones
}

/** The page a legacy `/celestia-pro?tab=…` link now points to, or `null` when the search carries no known tab. */
export const resolveLegacyCelestiaProTab = (search: string): string | null => {
  const tab = new URLSearchParams(search).get("tab")
  return tab !== null && Object.hasOwn(LEGACY_TAB_PATHS, tab) ? LEGACY_TAB_PATHS[tab] : null
}
